// extracted by mini-css-extract-plugin
export default {"inputContainer":"Form_inputContainer__rrbLV","btn":"Form_btn__dHmxA"};